<div class="search-form">
  <div class="create">
    <ng-container *ngIf="!loading">
      <div class="create-body">
        <div class="create-input">
          <form class="form" [formGroup]="createOrgForm">
            <div class="kompra-search">
              <input type="text" name="bin" formControlName="bin" class="form-control" placeholder="БИН организации" focus />
              <div class="btn btn-apply" (click)="searchAndUpdateOrganizationFromKompra()" [ngClass]="{'btn-success': isUpdatedFromKompra}">
                <ng-container *ngIf="loadingFromKompra">
                  <div class="loading"></div>
                </ng-container>
                <ng-container *ngIf="!loadingFromKompra">
                  <!-- {{ organization && organization.bin ? 'Обновить с kompra.kz' : 'Найти на kompra.kz' }} -->
                  <ng-container *ngIf="isCreateMode">
                    {{ isUpdatedFromKompra ? 'Найдено на kompra.kz': 'Найти на kompra.kz' }}
                  </ng-container>
                  <ng-container *ngIf="!isCreateMode">
                    {{ isUpdatedFromKompra ? 'Обновлено с kompra.kz': 'Обновить с kompra.kz' }}
                  </ng-container>
                  <!-- {{ isCreateMode ? 'Найти на kompra.kz': 'Обновить с kompra.kz' }} -->
                </ng-container>
              </div>
            </div>
            <input type="text" name="title" formControlName="title" class="form-control form-control--width-100" placeholder="Наименование организации" />

            <input type="text" name="mainPhone" formControlName="mainPhone" class="form-control" placeholder="Телефон" />
            <input type="text" name="director" formControlName="director" class="form-control" placeholder="ФИО руководителя"/>

            <input type="text" name="physicalAddress" formControlName="physicalAddress" class="form-control" placeholder="Адрес(Фактический)"/>
            <input type="text" name="registerAddress" formControlName="registerAddress" class="form-control" placeholder="Адрес(Юридический)"/>

            <input type="text" name="mainWebsite" formControlName="mainWebsite" class="form-control" placeholder="Веб-сайт" />
            <input type="text" name="mainEmail" formControlName="mainEmail" class="form-control" placeholder="Адрес электронной почты">

            <span class="developerTitle">{{developerTitle}}<sup>*</sup></span>
            <input type="text" name="contactPerson" formControlName="contactPerson" class="form-control form-control--width-100" placeholder="ФИО Контактного лица"/>
          </form>

          <div class="columns-wrapper">
            <div class="column">
              <div class="column__inner">
                <div class="column_form-control-item" *ngFor="let item of additionalPhones; let itemsIndex=index">
                  <input type="text" class="form-control" [(ngModel)]="item.value"  mask="+0 (000) 000 00 00" placeholder="Дополнительный телефон {{itemsIndex + 1}}"/>
                  <div class="icon" [ngClass]="{'remove-icon': additionalPhones.length > 1}" (click)="additionalPhones.length > 1 ? removeAdditionPhone(item, itemsIndex) : ''">&times;</div>
                  <div class="plus-icon icon" (click)="addAdditionalPhone(itemsIndex)">+</div>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="column__inner">
                <div class="column_form-control-item" *ngFor="let item of additionalEmails; let itemsIndex=index">
                  <input type="text" class="form-control" [ngClass]="{'form-control--error': item.errorEmail }" [(ngModel)]="item.value" placeholder="Дополнительный email {{itemsIndex + 1}}" (keyup)="emailValidate(item)" />
                  <div class="icon" [ngClass]="{'remove-icon': additionalEmails.length > 1}" (click)="additionalEmails.length > 1 ? removeAdditionlEmail(item, itemsIndex) : ''">&times;</div>
                  <div class="plus-icon icon" (click)="addAdditionalEmail(itemsIndex)">+</div>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="column__inner">
                <div class="column_form-control-item" *ngFor="let item of additionalWebsites; let itemsIndex=index">
                  <input type="text" class="form-control" [(ngModel)]="item.value" placeholder="Дополнительный веб-сайт {{itemsIndex + 1}}"/>
                  <div class="icon" [ngClass]="{'remove-icon': additionalWebsites.length > 1}" (click)="additionalWebsites.length > 1 ? removeAdditionWebsite(item, itemsIndex) : ''">&times;</div>
                  <div class="plus-icon icon" (click)="addAdditionalWebsite(itemsIndex)">+</div>
                </div>
              </div>
            </div>
          </div>

          <span class="developerTitle"><sup>*</sup>&nbsp;Обязательно для заполнения</span>
          <div class="types" style="display: none;">
            <div class="type" *ngFor="let type of typeList; let typeIndex = index">
              <!-- <input type="checkbox" id="type{{typeIndex}}" [(ngModel)]="type.active" (change)="changeTypeCheckbox($event, type)" [disabled]="type.disabled"> -->
              <input type="checkbox" id="type{{typeIndex}}" [(ngModel)]="type.active" [disabled]="type.disabled">
              <label for="type{{typeIndex}}">
                {{ type.title }}
              </label>
            </div>
          </div>
        </div>
        <div class="search-form__footer">
          <div class="btn"
              [ngClass]="{'btn-apply': isUpdatedFromKompra || organizationInfo?.isValidBIN,
                          'btn-disabled': !(isUpdatedFromKompra || this.organizationInfo?.isValidBIN)}"
              (click)="isUpdatedFromKompra || this.organizationInfo?.isValidBIN ? createItem() : ''">
              <ng-container *ngIf="saveLoading; else successButton">
                <div class="loading btn-loading"></div>
              </ng-container>
              <ng-template #successButton>
                {{ isCreateMode ? 'Добавить' : 'Сохранить' }}
              </ng-template>
          </div>
          <div class="btn btn-cancel" (click)="close()"> Отмена</div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="loading">
      <div class="loading"></div>
    </ng-container>
  </div>
</div>
